var map = {
	"./add.svg": 57551,
	"./after-sales.svg": 21515,
	"./cust-serv.svg": 13576,
	"./customer.svg": 32362,
	"./empty.svg": 99625,
	"./feedback.svg": 45175,
	"./home.svg": 76387,
	"./hot.svg": 79243,
	"./image_edit.svg": 89448,
	"./like.svg": 69863,
	"./like_fill.svg": 69433,
	"./phone.svg": 9074,
	"./qa.svg": 13020,
	"./qn-feedback-logo.svg": 2959,
	"./right-arrow.svg": 89896,
	"./start.svg": 41058
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20527;